import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { IconsModule } from 'wflow-ui';
import { WfIconName } from 'wflow-ui/icons/icon/wf-icons-name.type';
import { NgOptimizedImage } from '@angular/common';

export interface WfFileListEntry {
  id: string;
  name: string;
  iconUrl?: string;
  iconName?: WfIconName;
  downloadable?: boolean;
}

@Component({
  selector: 'wf-file-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [IconsModule, NgOptimizedImage],
  templateUrl: './file-list.component.html',
  styleUrl: './file-list.component.scss',
  host: { class: 'wf-file-list' },
})
export class WfFileListComponent {
  readonly files = input.required<readonly WfFileListEntry[]>();
  readonly activeFileId = input<string | null>(null);

  readonly view = output<WfFileListEntry>();
  readonly download = output<WfFileListEntry>();

  protected onView(file: WfFileListEntry): void {
    this.view.emit(file);
  }

  protected onDownload(file: WfFileListEntry, event: Event): void {
    event.stopPropagation();
    this.download.emit(file);
  }
}
